/**
 * Maritime Identification Digits (MID) mapping.
 *
 * The first three digits of a 9-digit MMSI encode the vessel's flag state
 * per ITU-R M.585. This module provides lookup in both directions plus
 * helpers for generating valid MMSI strings and country-appropriate call
 * sign prefixes.
 */

/** MID → country name (ITU-R M.585-9) */
export const MID_TO_COUNTRY: Record<string, string> = {
  '201': 'Albania',
  '202': 'Andorra',
  '203': 'Austria',
  '204': 'Azores',
  '205': 'Belgium',
  '206': 'Belarus',
  '207': 'Bulgaria',
  '208': 'Vatican',
  '209': 'Cyprus',
  '210': 'Cyprus',
  '211': 'Germany',
  '212': 'Cyprus',
  '213': 'Georgia',
  '214': 'Moldova',
  '215': 'Malta',
  '216': 'Armenia',
  '218': 'Germany',
  '219': 'Denmark',
  '220': 'Denmark',
  '224': 'Spain',
  '225': 'Spain',
  '226': 'France',
  '227': 'France',
  '228': 'France',
  '229': 'Malta',
  '230': 'Finland',
  '231': 'Faroe Islands',
  '232': 'United Kingdom',
  '233': 'United Kingdom',
  '234': 'United Kingdom',
  '235': 'United Kingdom',
  '236': 'Gibraltar',
  '237': 'Greece',
  '238': 'Croatia',
  '239': 'Greece',
  '240': 'Greece',
  '241': 'Greece',
  '242': 'Morocco',
  '243': 'Hungary',
  '244': 'Netherlands',
  '245': 'Netherlands',
  '246': 'Netherlands',
  '247': 'Italy',
  '248': 'Malta',
  '249': 'Malta',
  '250': 'Ireland',
  '251': 'Iceland',
  '252': 'Liechtenstein',
  '253': 'Luxembourg',
  '254': 'Monaco',
  '255': 'Madeira',
  '256': 'Malta',
  '257': 'Norway',
  '258': 'Norway',
  '259': 'Norway',
  '261': 'Poland',
  '262': 'Montenegro',
  '263': 'Portugal',
  '264': 'Romania',
  '265': 'Sweden',
  '266': 'Sweden',
  '267': 'Slovakia',
  '268': 'San Marino',
  '269': 'Switzerland',
  '270': 'Czech Republic',
  '271': 'Turkey',
  '272': 'Ukraine',
  '273': 'Russia',
  '274': 'North Macedonia',
  '275': 'Latvia',
  '276': 'Estonia',
  '277': 'Lithuania',
  '278': 'Slovenia',
  '279': 'Serbia',
  '301': 'Anguilla',
  '303': 'USA',
  '304': 'Antigua and Barbuda',
  '305': 'Antigua and Barbuda',
  '306': 'Curaçao',
  '307': 'Aruba',
  '308': 'Bahamas',
  '309': 'Bahamas',
  '310': 'Bermuda',
  '311': 'Bahamas',
  '312': 'Belize',
  '314': 'Barbados',
  '316': 'Canada',
  '319': 'Cayman Islands',
  '321': 'Costa Rica',
  '323': 'Cuba',
  '325': 'Dominica',
  '327': 'Dominican Republic',
  '329': 'Guadeloupe',
  '330': 'Grenada',
  '331': 'Greenland',
  '332': 'Guatemala',
  '334': 'Honduras',
  '336': 'Haiti',
  '338': 'USA',
  '339': 'Jamaica',
  '341': 'Saint Kitts and Nevis',
  '343': 'Saint Lucia',
  '345': 'Mexico',
  '347': 'Martinique',
  '348': 'Montserrat',
  '350': 'Nicaragua',
  '351': 'Panama',
  '352': 'Panama',
  '353': 'Panama',
  '354': 'Panama',
  '355': 'Panama',
  '356': 'Panama',
  '357': 'Panama',
  '358': 'Puerto Rico',
  '359': 'El Salvador',
  '361': 'Saint Pierre and Miquelon',
  '362': 'Trinidad and Tobago',
  '364': 'Turks and Caicos',
  '366': 'USA',
  '367': 'USA',
  '368': 'USA',
  '369': 'USA',
  '370': 'Panama',
  '371': 'Panama',
  '372': 'Panama',
  '373': 'Panama',
  '374': 'Panama',
  '375': 'Saint Vincent and the Grenadines',
  '376': 'Saint Vincent and the Grenadines',
  '377': 'Saint Vincent and the Grenadines',
  '378': 'British Virgin Islands',
  '379': 'US Virgin Islands',
  '401': 'Afghanistan',
  '403': 'Saudi Arabia',
  '405': 'Bangladesh',
  '408': 'Bahrain',
  '410': 'Bhutan',
  '412': 'China',
  '413': 'China',
  '414': 'China',
  '416': 'Taiwan',
  '417': 'Sri Lanka',
  '419': 'India',
  '422': 'Iran',
  '423': 'Azerbaijan',
  '425': 'Iraq',
  '428': 'Israel',
  '431': 'Japan',
  '432': 'Japan',
  '434': 'Turkmenistan',
  '436': 'Kazakhstan',
  '437': 'Uzbekistan',
  '438': 'Jordan',
  '440': 'South Korea',
  '441': 'South Korea',
  '443': 'Palestine',
  '445': 'North Korea',
  '447': 'Kuwait',
  '450': 'Lebanon',
  '451': 'Kyrgyzstan',
  '453': 'Macao',
  '455': 'Maldives',
  '457': 'Mongolia',
  '459': 'Nepal',
  '461': 'Oman',
  '463': 'Pakistan',
  '466': 'Qatar',
  '468': 'Syria',
  '470': 'UAE',
  '471': 'UAE',
  '472': 'Tajikistan',
  '473': 'Yemen',
  '475': 'Yemen',
  '477': 'Hong Kong',
  '478': 'Bosnia and Herzegovina',
  '501': 'Antarctica',
  '503': 'Australia',
  '506': 'Myanmar',
  '508': 'Brunei',
  '510': 'Micronesia',
  '511': 'Palau',
  '512': 'New Zealand',
  '514': 'Cambodia',
  '515': 'Cambodia',
  '516': 'Christmas Island',
  '518': 'Cook Islands',
  '520': 'Fiji',
  '523': 'Cocos Islands',
  '525': 'Indonesia',
  '529': 'Kiribati',
  '531': 'Laos',
  '533': 'Malaysia',
  '536': 'Northern Mariana Islands',
  '538': 'Marshall Islands',
  '540': 'New Caledonia',
  '542': 'Niue',
  '544': 'Nauru',
  '546': 'French Polynesia',
  '548': 'Philippines',
  '553': 'Papua New Guinea',
  '555': 'Pitcairn Islands',
  '557': 'Solomon Islands',
  '559': 'American Samoa',
  '561': 'Samoa',
  '563': 'Singapore',
  '564': 'Singapore',
  '565': 'Singapore',
  '566': 'Singapore',
  '567': 'Thailand',
  '570': 'Tonga',
  '572': 'Tuvalu',
  '574': 'Vietnam',
  '576': 'Vanuatu',
  '577': 'Vanuatu',
  '578': 'Wallis and Futuna',
  '601': 'South Africa',
  '603': 'Angola',
  '605': 'Algeria',
  '607': 'Saint Paul and Amsterdam Islands',
  '608': 'Ascension Island',
  '609': 'Burundi',
  '610': 'Benin',
  '611': 'Botswana',
  '612': 'Central African Republic',
  '613': 'Cameroon',
  '615': 'Congo',
  '616': 'Comoros',
  '617': 'Cabo Verde',
  '618': 'Crozet Archipelago',
  '619': 'Ivory Coast',
  '620': 'Comoros',
  '621': 'Djibouti',
  '622': 'Egypt',
  '624': 'Ethiopia',
  '625': 'Eritrea',
  '626': 'Gabon',
  '627': 'Ghana',
  '629': 'Gambia',
  '630': 'Guinea-Bissau',
  '631': 'Equatorial Guinea',
  '632': 'Guinea',
  '633': 'Burkina Faso',
  '634': 'Kenya',
  '635': 'Kerguelen Islands',
  '636': 'Liberia',
  '637': 'Liberia',
  '638': 'South Sudan',
  '642': 'Libya',
  '644': 'Lesotho',
  '645': 'Mauritius',
  '647': 'Madagascar',
  '649': 'Mali',
  '650': 'Mozambique',
  '654': 'Mauritania',
  '655': 'Malawi',
  '656': 'Niger',
  '657': 'Nigeria',
  '659': 'Namibia',
  '660': 'Réunion',
  '661': 'Rwanda',
  '662': 'Sudan',
  '663': 'Senegal',
  '664': 'Seychelles',
  '665': 'Saint Helena',
  '666': 'Somalia',
  '667': 'Sierra Leone',
  '668': 'São Tomé and Príncipe',
  '669': 'Eswatini',
  '670': 'Chad',
  '671': 'Togo',
  '672': 'Tunisia',
  '674': 'Tanzania',
  '675': 'Uganda',
  '676': 'Democratic Republic of the Congo',
  '677': 'Tanzania',
  '678': 'Zambia',
  '679': 'Zimbabwe',
  '701': 'Argentina',
  '710': 'Brazil',
  '720': 'Bolivia',
  '725': 'Chile',
  '730': 'Colombia',
  '735': 'Ecuador',
  '740': 'Falkland Islands',
  '745': 'Guiana',
  '750': 'Guyana',
  '755': 'Paraguay',
  '760': 'Peru',
  '765': 'Suriname',
  '770': 'Uruguay',
  '775': 'Venezuela',
};

/** Country name → primary MID (first one found in the table). */
const COUNTRY_TO_MID: Record<string, string> = {};
for (const [mid, country] of Object.entries(MID_TO_COUNTRY)) {
  if (!(country in COUNTRY_TO_MID)) {
    COUNTRY_TO_MID[country] = mid;
  }
}

/**
 * ITU call sign prefix allocations per country (subset of common maritime
 * nations). Each entry lists one or more 2-character prefixes allocated to
 * that country. A generated call sign is built as prefix + random suffix.
 */
const COUNTRY_CALLSIGN_PREFIXES: Record<string, string[]> = {
  Denmark: ['OX', 'OY', 'OZ', 'XP'],
  Norway: [
    'LA',
    'LB',
    'LC',
    'LD',
    'LE',
    'LF',
    'LG',
    'LH',
    'LI',
    'LJ',
    'LK',
    'LL',
    'LM',
    'LN',
  ],
  Sweden: [
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SF',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
  ],
  Finland: ['OF', 'OG', 'OH', 'OI'],
  Germany: [
    'DA',
    'DB',
    'DC',
    'DD',
    'DE',
    'DF',
    'DG',
    'DH',
    'DI',
    'DJ',
    'DK',
    'DL',
    'DM',
    'DN',
    'DO',
    'DP',
    'DQ',
    'DR',
  ],
  'United Kingdom': [
    'GA',
    'GB',
    'GC',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GJ',
    'GK',
    'GL',
    'GM',
    'GN',
    'GO',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GV',
    'GW',
    'GX',
    'GY',
    'GZ',
    'MA',
    'MB',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MI',
    'MJ',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
  ],
  France: [
    'FA',
    'FB',
    'FC',
    'FD',
    'FE',
    'FF',
    'FG',
    'FH',
    'FI',
    'FJ',
    'FK',
    'FL',
    'FM',
    'FN',
    'FO',
    'FP',
    'FQ',
    'FR',
    'FS',
    'FT',
    'FU',
    'FV',
    'FW',
    'FX',
    'FY',
    'FZ',
  ],
  Netherlands: ['PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'PG', 'PH', 'PI'],
  Italy: [
    'IA',
    'IB',
    'IC',
    'ID',
    'IE',
    'IF',
    'IG',
    'IH',
    'II',
    'IJ',
    'IK',
    'IL',
    'IM',
    'IN',
    'IO',
    'IP',
    'IQ',
    'IR',
    'IS',
    'IT',
    'IU',
    'IV',
    'IW',
    'IX',
    'IY',
    'IZ',
  ],
  Spain: ['EA', 'EB', 'EC', 'ED', 'EE', 'EF', 'EG', 'EH'],
  Greece: ['SV', 'SW', 'SX', 'SY', 'SZ'],
  USA: [
    'KA',
    'KB',
    'KC',
    'KD',
    'KE',
    'KF',
    'KG',
    'KH',
    'KI',
    'KJ',
    'KK',
    'KL',
    'KM',
    'KN',
    'KO',
    'KP',
    'KQ',
    'KR',
    'KS',
    'KT',
    'KU',
    'KV',
    'KW',
    'KX',
    'KY',
    'KZ',
    'WA',
    'WB',
    'WC',
    'WD',
    'WE',
    'WF',
    'WG',
    'WH',
    'WI',
    'WJ',
    'WK',
    'WL',
    'WM',
    'WN',
    'WO',
    'WP',
    'WQ',
    'WR',
    'WS',
    'WT',
    'WU',
    'WV',
    'WW',
    'WX',
    'WY',
    'WZ',
  ],
  Canada: ['CF', 'CG', 'CH', 'CI', 'CJ', 'CK'],
  Panama: ['HP', '3E', '3F', 'H3', 'H9', 'HO'],
  Liberia: ['A8', 'EL', '5L', '5M', '6Z', 'D5'],
  'Marshall Islands': ['V7'],
  Malta: ['9H'],
  Bahamas: ['C6'],
  Singapore: ['9V', 'S6'],
  China: [
    'BA',
    'BB',
    'BC',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BK',
    'BL',
    'BM',
    'BN',
    'BO',
    'BP',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BU',
    'BV',
    'BW',
    'BX',
    'BY',
    'BZ',
    'XS',
  ],
  Japan: [
    'JA',
    'JB',
    'JC',
    'JD',
    'JE',
    'JF',
    'JG',
    'JH',
    'JI',
    'JJ',
    'JK',
    'JL',
    'JM',
    'JN',
    'JO',
    'JP',
    'JQ',
    'JR',
    'JS',
  ],
  'South Korea': ['HL', 'DS', 'DT', '6K', '6L', '6M', '6N'],
  India: ['AT', 'AU', 'AV', 'AW', 'VT', 'VU', 'VV', 'VW'],
  Russia: [
    'RA',
    'RB',
    'RC',
    'RD',
    'RE',
    'RF',
    'RG',
    'RH',
    'RI',
    'RJ',
    'RK',
    'RL',
    'RM',
    'RN',
    'RO',
    'RP',
    'RQ',
    'RR',
    'RS',
    'RT',
    'RU',
    'RV',
    'RW',
    'RX',
    'RY',
    'RZ',
    'UA',
    'UB',
    'UC',
    'UD',
    'UE',
    'UF',
    'UG',
    'UH',
    'UI',
  ],
  Brazil: ['PP', 'PQ', 'PR', 'PS', 'PT', 'PU', 'PV', 'PW', 'PX', 'PY'],
  Australia: ['AX', 'VH', 'VI', 'VJ', 'VK', 'VL', 'VM', 'VN'],
  'Hong Kong': ['VR'],
};

/**
 * Get the country name for an MMSI string using its MID (first 3 digits).
 * Returns `undefined` for invalid or unrecognised MIDs.
 */
export function getCountryFromMmsi(mmsi: string): string | undefined {
  if (mmsi.length < 3) return undefined;
  return MID_TO_COUNTRY[mmsi.substring(0, 3)];
}

/**
 * Get all MIDs allocated to a given country name.
 * Returns an empty array if the country is not found.
 */
export function getMidsForCountry(country: string): string[] {
  return Object.entries(MID_TO_COUNTRY)
    .filter(([, c]) => c === country)
    .map(([mid]) => mid);
}

/**
 * Generate a valid 9-digit MMSI string for a given country.
 * Uses a random MID allocated to that country plus 6 random digits.
 * Falls back to Denmark (MID 219) if the country has no MID.
 */
export function generateMmsi(country: string): string {
  const mids = getMidsForCountry(country);
  const mid =
    mids.length > 0 ? mids[Math.floor(Math.random() * mids.length)] : '219';
  const suffix = String(Math.floor(Math.random() * 1_000_000)).padStart(6, '0');
  return `${mid}${suffix}`;
}

/**
 * Generate a valid IMO number (7 digits with correct check digit).
 * The check digit is: sum of (digit[i] × (7−i)) for i=0..5, mod 10.
 */
export function generateImo(): number {
  // First 6 digits: 9xxxxxx range (IMO numbers start with 9 for modern vessels)
  const d = [9, 0, 0, 0, 0, 0];
  for (let i = 1; i < 6; i++) {
    d[i] = Math.floor(Math.random() * 10);
  }
  const checkDigit =
    (d[0] * 7 + d[1] * 6 + d[2] * 5 + d[3] * 4 + d[4] * 3 + d[5] * 2) % 10;
  return Number(d.join('') + checkDigit);
}

/**
 * Generate a call sign appropriate for the given country.
 * Uses ITU-allocated prefix + random alphanumeric suffix (4–5 chars total).
 * Falls back to a generic 4-letter call sign if no prefix table entry exists.
 */
export function generateCallSign(country: string): string {
  const prefixes = COUNTRY_CALLSIGN_PREFIXES[country];
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  if (prefixes && prefixes.length > 0) {
    const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
    // 2-char prefix + 2 random letters = 4-char call sign
    const suffix = Array.from(
      { length: 2 },
      () => chars[Math.floor(Math.random() * 26)],
    ).join('');
    return prefix + suffix;
  }

  // Fallback: 4 random letters
  return Array.from(
    { length: 4 },
    () => chars[Math.floor(Math.random() * 26)],
  ).join('');
}
